// packages/shared/src/utils/crypto/unwrapVaultKey.js

function base64ToUint8Array(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes;
}

export async function decryptWrappedVaultKey({ wrappedKey, kek }) {
  if (!wrappedKey) {
    throw new Error('wrappedKey is required');
  }

  const cryptoObj = globalThis.crypto;
  if (!cryptoObj?.subtle) {
    throw new Error('Web Crypto API is not available');
  }

  const data = base64ToUint8Array(wrappedKey);

  const iv = data.slice(0, 12);
  const ciphertext = data.slice(12);

  const decrypted = await cryptoObj.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv,
    },
    kek,
    ciphertext
  );

  // The unlocked vault key must be extractable while it is held in memory
  // so it can be re-wrapped when the user changes the vault passphrase or
  // generates a new recovery key. It is still cleared when the vault locks.
  return cryptoObj.subtle.importKey(
    'raw',
    decrypted,
    { name: 'AES-GCM', length: 256 },
    true,
    ['encrypt', 'decrypt']
  );
}
